var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"calculator"},[_c('lms-calculator-light'),_c('div',{staticClass:"button-container"},[_c('router-link',{attrs:{"to":_vm.loginPage}},[_c('el-button',{attrs:{"type":"primary"}},[_vm._v(" "+_vm._s(_vm.$t('LAYOUT_SECTIONS.SECTION_MAIN.BUTTON'))+" ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }